import React from 'react';
import { PropTypes } from 'prop-types';

import { isEmpty } from 'utils/types';
import Select, { components } from 'components/CustomSelect';
import { Icon } from '@ontruck/orc';

const Option = ({ children, ...props }) => (
  <components.Option {...props} className="option">
    {children}
  </components.Option>
);

const DropdownIndicator = (props) => (
  <components.DropdownIndicator {...props}>
    <Icon glyph="arrowtip-down" size="16px" color="grey500" />
  </components.DropdownIndicator>
);

const FilterUser = ({ user, t, users, setUserFilter, className }) => (
  <div className={className}>
    <Select
      value={!isEmpty(user) && { value: user.id, label: user.name, ...user }}
      placeholder={t('all_users')}
      options={[
        { value: false, label: t('all_users') },
        ...users.map((userOption) => ({
          value: userOption.id,
          label: t('from_user', { user: userOption.name }),
          ...userOption,
        })),
      ]}
      components={{ Option, DropdownIndicator }}
      isSearchable={false}
      noBorder
      onChange={setUserFilter}
    />
  </div>
);

FilterUser.propTypes = {
  t: PropTypes.func,
  users: PropTypes.string,
  setUserFilter: PropTypes.func,
  user: PropTypes.number,
};

FilterUser.defaultProps = {
  t: () => {},
  users: '',
  setUserFilter: () => {},
  user: false,
  numberOfOrders: 0,
};

export default FilterUser;
